import React  from 'react';
//import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { PaginationTotal } from '../../../commons/controls';
import _ from 'lodash';
import Lib from '../../../commons/lib';

let node;

const SzemelyContent = props => {

  const {
    hasSzemely,
    selectedSzemely,
    onRowSelect,
    szemelyData,
  } = props;

  const renderTable = () => {
    const sizePerPage = (node && node.paginationContext.currSizePerPage) || 25;
    const page = hasSzemely ? (1 + Math.floor(szemelyData.map(p => p.id).indexOf(selectedSzemely[0].id) / sizePerPage)) : 1;

    if(node){
      node.paginationContext.currPage = page;
    }
    
    const selected = hasSzemely ? selectedSzemely.map(szemely => szemely.id) : [];
    const selectRow = {
      selected: selected,
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      onSelect: onRowSelect,
      style: { backgroundColor: '#c8e6c9' }
      //style: { background: 'red' }
    }

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'beosztas.nev',
        text: 'Beosztás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'helyszinek',
        text: 'Helyszínek',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell && cell.map( h => h.nev).join(', ')
      },
      {
        dataField: 'email',
        text: 'Email',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: '',
        hidden: true,
      },
    ];

    return (
        <div className="animated fadeIn">
          <BootstrapTable
            ref={ n => node = n }
            bootstrap4
            keyField="id"
            data={szemelyData}
            columns={columns}
            bordered={false} 
            selectRow={selectRow}
            filter={filterFactory()}
            pagination={paginationFactory({...Lib.bootstraptableProps, sizePerPage: 10})}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderTable()}
      </div>
    </div>
  );
}

export default SzemelyContent;